/* eslint-disable */
/* tslint:disable */

/** updateNotificationPreferencesByTemplate
 * method: put
 * summary: Update the channel notification preferences by template
 */

import type {
  UpdateNotificationPreferencesByTemplateBodyDto,
  GeneralOkNotOkResultDto,
  ApiResponseDto,
} from './../api-types'

export const path = `/bff-worker/user-preferences/hubler-notifications`
export const fullPath = `${process.env.BFF_WORKER_BASE_URL || 'http://bff-worker.svc.cluster.local'}/bff-worker/user-preferences/hubler-notifications`

export type RequestBody = UpdateNotificationPreferencesByTemplateBodyDto

export type UpdateNotificationPreferencesByTemplateSuccess =
  GeneralOkNotOkResultDto
export type UpdateNotificationPreferencesByTemplateError = ApiResponseDto
